import { FETCH_REQUEST_COMMENTS, POST_COMMENT } from 'actions/types';

const fetchComments = (action, state) => {
  if (!action.payload.data) return state;

  const { meta, data } = action.payload.data;
  return { pager: meta, data };
};

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_REQUEST_COMMENTS:
      return fetchComments(action, state);
    case POST_COMMENT:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/comments.js